<template>
  <main class="chief-page">
    <div class="chief-page__body">
      <h1 class="chief-page__title">ЕГИСЗ</h1>
      <date-range-with-presets
        v-if="selectedPeriod.length > 0"
        v-bind:presets="periodPresets"
        v-model="selectedPeriod"
        v-on:close="fetchVisits"
        v-on:input-preset="onInputPreset"
      />
      <input-text-search
        class="chief-page__search"
        placeholder="Введите ФИО или номер медицинской карты"
        v-bind:violations="searchQueryInputError"
        v-model="searchQuery"
      />
      <div class="chief-page__filters">
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByAll"
          v-bind:value="$options.filterByAll"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter"
          v-bind:for="$options.filterByAll"
        >Все</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterByNew"
          v-bind:value="$options.filterByNew"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter chief-page__icon new"
          v-bind:for="$options.filterByNew"
        >Черновики ({{ newCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterToVerify"
          v-bind:value="$options.filterToVerify"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter chief-page__icon to-verify"
          v-bind:for="$options.filterToVerify"
        >На проверку ({{ toVerifyCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterVerified"
          v-bind:value="$options.filterVerified"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter chief-page__icon verified"
          v-bind:for="$options.filterVerified"
        >Верифицирована ({{ verifiedCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterSendToEGISZ"
          v-bind:value="$options.filterSendToEGISZ"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter chief-page__icon"
          v-bind:for="$options.filterSendToEGISZ"
        >Отправлено в ЕГИСЗ ({{ sendToEGISZCount }})</label>
        <input
          hidden
          type="radio"
          v-bind:id="$options.filterEGISZError"
          v-bind:value="$options.filterEGISZError"
          v-on:input="onInputFilter"
          v-model="filterByStatus"
        >
        <label
          class="chief-page__filters__filter chief-page__icon rejected"
          v-bind:for="$options.filterEGISZError"
        >Ошибка ЕГИСЗ ({{ egiszErrorCount }})</label>
      </div>
      <div
        class="chief-page__cards"
        v-if="!this.isVisitListEmpty && !this.isAwaitRequest"
      >
        <div
          class="chief-page__card"
          v-for="visit in visitList"
          v-bind:key="visit.id"
        >
          <div
            class="chief-page__card__status"
            v-bind:class="visit.status"
          >
            {{ visit.status_title }}
          </div>
          <div class="chief-page__card__column">
            <div class="chief-page__card__text">
              Пациент:
              <router-link
                v-bind:to="{
                  name: 'ClinicPanelPatientBasic',
                  params: { id: visit.patient_id },
                }"
              >
                {{ visit.patient_name }}
              </router-link>
            </div>
            <div class="chief-page__card__text">
              Врач:
              <router-link
                v-bind:to="{
                  name: 'ClinicPanelEmployeeProfileBasic',
                  params: { id: visit.employee_id },
                }"
              >
                {{ visit.employee_name }}
              </router-link>
            </div>
            <div class="chief-page__card__text">
              Должность врача:
              <autocomplete-input
                class="chief-page__card__input"
                v-bind:disabled="visit.hasInactiveCdaSignature
                  || !visit.needsSignature
                  || visit.cda_document_id !== null"
                item-text="name"
                item-value="id"
                v-bind:items="visit.employee_medical_positions"
                v-bind:menu-props="{
                  contentClass: 'text-small',
                  maxWidth: 'min(15%, 400px)',
                }"
                v-model="visit.cdaDoctorPosition"
              />
            </div>
            <div class="chief-page__card__text">
              Специальность врача:
              <autocomplete-input
                class="chief-page__card__input"
                v-bind:disabled="visit.hasInactiveCdaSignature
                  || !visit.needsSignature
                  || visit.cda_document_id !== null"
                item-text="name"
                item-value="id"
                v-bind:items="visit.employee_specialities"
                v-bind:menu-props="{
                  contentClass: 'text-small',
                  maxWidth: 'min(15%, 400px)',
                }"
                v-model="visit.cdaDoctorSpeciality"
              />
            </div>
            <router-link
              class="chief-page__card__link"
              v-bind:class="{ warn: visit.has_error_explanation }"
              v-bind:to="visit.protocolLinkTo"
            >
              Протокол приёма от {{ visit.date }}
              <span />
            </router-link>
          </div>
          <div class="chief-page__card__signature">
            <div class="chief-page__card__items">
              <span
                class="chief-page__card__item"
                v-bind:class="{ signed: visit.has_doctor_signature }"
              >ЭЦП врача</span>
              <span
                class="chief-page__card__item"
                v-bind:class="{ signed: visit.has_clinic_signature }"
              >ЭЦП клиники</span>
            </div>
            <button
              class="chief-page__card__button"
              type="button"
              v-if="visit.needsSignature"
              v-on:click.prevent="onCreateCdaConsultationProtocolSignature(
                visit.id,
                visit.needsToNotifyDisallowRevisionVisitAfterClinicSigning,
                visit.cdaDoctorPosition,
                visit.cdaDoctorSpeciality,
              )"
            >Подписать</button>
            <button
              class="chief-page__card__button inactive"
              type="button"
              v-else-if="visit.hasInactiveCdaSignature"
              v-on:click.prevent="showInactiveCdaSignature(visit.inactiveCdaSignatureActions)"
            >Подписать</button>
            <button
              class="chief-page__card__button"
              type="button"
              v-if="visit.possiblesCancel"
              v-on:click.prevent="onCancelCdaConsultationProtocolSignature(
                visit.cda_document_id,
              )"
            >Отменить подпись</button>
            <button
              class="chief-page__card__button"
              type="button"
              v-if="visit.needsSending"
              v-on:click.prevent="onSendCdaConsultationProtocol(visit.cda_document_id)"
            >Отправить</button>
            <button
              class="chief-page__card__button"
              type="button"
              v-if="visit.needsSendingAgain"
              v-on:click.prevent="onSendCdaConsultationProtocolAgain(visit.cda_document_id)"
            >Отправить повторно</button>
            <button
              class="chief-page__card__button inactive"
              type="button"
              v-else-if="visit.hasInactiveCdaSendAgain"
              v-on:click.prevent="showInactiveCdaSignature(visit.inactiveCdaSendAgainActions)"
            >Отправить повторно</button>
          </div>
        </div>
      </div>
      <div
        v-else-if="!isAwaitRequest"
        class="chief-page__result"
      >
        Ничего не найдено
      </div>
      <the-pagination v-model="page" v-bind:page-count="pageCount" />
    </div>
    <modal-dialog
      title="Подпись СЭМД протокола консультации"
      v-bind:value="needsCryptoProCertificateSelectionAndPreview"
      v-on:input="onCancelCryptoProCertificateSelectionAndPreview"
      with-cross
    >
      <iframe
        height="300px"
        title="СЭМД протокола консультации"
        v-bind:srcdoc="consultationProtocolHtml"
        width="700px" />
      <fieldset>
        <legend>Выберите необходимый для подписи сертификат</legend>
        <input-radio
          identifier="crypto-pro-signature-certificate"
          v-bind:items="cryptoProSignatureCertificates"
          v-bind:value="cryptoProSignatureSelectedCertificate"
          v-on:input="onSelectCryptoProSignatureCertificate" />
        <strong v-if="needsClinicSigningNotify">
          После подписи карты ЭЦП клиники нельзя отправить карту на доработку.
          Подписать?
        </strong>
      </fieldset>
    </modal-dialog>
  </main>
</template>

<script>
import InputRadio from '@/components/InputRadio.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import ThePagination from '@/components/ThePagination.vue';
import cryptoProSignatureMixin from '@/mixins/cryptoProSignatureMixin';
import debounce from 'lodash.debounce';
import inputTextSearch from '@/components/InputTextSearch.vue';
import notifierMixin from '@/mixins/notifierMixin';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import DateRangeWithPresets from '@/components/DateRangeWithPresets.vue';
import { getISODateStringByDate } from '@/mixins/dateMixin';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Страница модуля главного врача.
 * @type {Vue}
 */
export default {
  components: {
    AutocompleteInput,
    DateRangeWithPresets,
    InputRadio,
    ModalDialog,
    ThePagination,
    inputTextSearch,
  },
  filterByAll: 'all',
  filterToVerify: 'to-verify',
  filterByNew: 'new',
  filterVerified: 'verified',
  filterSendToEGISZ: 'send-to-egisz',
  filterEGISZError: 'register-error',
  computed: {
    /**
     * @description Необходим выбор сертификата с предпросмотром СЭМД
     *              протокола консультации.
     */
    needsCryptoProCertificateSelectionAndPreview() {
      return this.needsCryptoProCertificateSelection && this.consultationProtocolHtml !== null;
    },
    searchQueryInputError: resolveInputErrors('match'),
    /**
     * @description Запрос.
     * @type {{match:string,status:string}}
     */
    viewQuery() {
      return {
        match: this.searchQuery,
        status: this.filterByStatus,
        page: this.page,
      };
    },
    /**
     * @description Визиты на показ.
     */
    visitList() {
      return this.fetchedVisits.map((item) => {
        const { allowed_actions: allowedActions = [] } = item;
        const inactiveCdaSendAgainActions = (item.inactive_actions || [])
          .filter(({ name }) => (name === 'send-again'));
        const inactiveCdaSignatureActions = (item.inactive_actions || [])
          .filter(({ name }) => (name === 'signature'));
        const needsToNotifyDisallowRevisionVisitAfterClinicSigning = allowedActions
          .includes('clinic-signature');
        const needsPreview = allowedActions.includes('preview');
        const needsSending = allowedActions.includes('send-consultation-protocol');
        const needsSendingAgain = allowedActions.includes('send-consultation-protocol-again');
        const needsSignature = ['clinic-signature', 'doctor-signature'].some(
          (candidate) => allowedActions.includes(candidate),
        );
        const possiblesCancel = allowedActions.includes('cancel-signature');
        const cdaDoctorPosition = item.cda_doctor_position
            ?? item.employee_medical_positions.slice(0, 1).map(({ id }) => id).at(0);
        const cdaDoctorSpeciality = item.cda_doctor_speciality
            ?? item.employee_specialities.slice(0, 1).map(({ id }) => id).at(0);
        return {
          ...item,
          hasInactiveCdaSignature: inactiveCdaSignatureActions.length !== 0,
          hasInactiveCdaSendAgain: inactiveCdaSendAgainActions.length !== 0,
          inactiveCdaSendAgainActions,
          inactiveCdaSignatureActions,
          needsToNotifyDisallowRevisionVisitAfterClinicSigning,
          needsSending,
          needsSendingAgain,
          needsSignature,
          possiblesCancel,
          cdaDoctorPosition,
          cdaDoctorSpeciality,
          protocolLinkTo: needsPreview ? {
            name: 'ClinicPanelChiefPhysicianVisit',
            params: { id: item.id },
          } : {
            name: 'ClinicPanelPatientVisit',
            params: {
              id: item.patient_id,
              visitId: item.id,
            },
          },
        };
      });
    },
    /**
     * @description Является ли список визитов пустым.
     * @returns {boolean}
     */
    isVisitListEmpty() {
      return !Object.keys(this.fetchedVisits).length;
    },
    /**
     * @description Предварительные установки периодов.
     * @returns {{toValue: function(): [Date,Date], id: string, label: string, title: string}[]}
     */
    periodPresets() {
      return this.periodTypes.map(({ periodDates, title, value }) => ({
        id: value,
        label: title,
        title,
        toValue: () => periodDates,
      }));
    },
  },
  created() {
    const onSuccess = (response) => {
      this.periodTypes = response
        .period_types
        .map(({
          from_to: [from, to], title, value, selected,
        }) => ({
          periodDates: [new Date(from), new Date(to)],
          title,
          value,
          selected,
        }));
      this.periodTypes.forEach((period) => {
        if (period.selected) {
          this.selectedPeriod = period.periodDates;
        }
      });
      this.fetchVisits();
    };
    const onFail = (error) => {
      this.notifyFail(error.getTitle());
    };
    this
      .$chiefPhysicianGateway
      .viewVisitListOptions()
      .then((result) => result.fold(onFail, onSuccess));
  },
  data() {
    return {
      /**
       * @description Документ предпросмотра СЭМД протокола консультации.
       * @type {(string|null)}
       */
      consultationProtocolHtml: null,
      /**
       * @description Необходимо предупредить о последующем запрете отправки
       *              визита на доработку.
       * @type {boolean}
       */
      needsClinicSigningNotify: false,
      /**
       * @description Номер страницы.
       * @type {number}
       */
      page: 1,
      /**
       * @description Количество страниц.
       * @type {number}
       */
      pageCount: 0,
      /**
       * @description Список визитов.
       * @type {Object[]}
       */
      fetchedVisits: [],
      /**
       * @description Фильтр по статусу.
       * @type {string}
       */
      filterByStatus: this.$options.filterByAll,
      /**
       * @description Поисковой запрос.
       * @type {string}
       */
      searchQuery: '',
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      inputErrors: {},
      /**
       * @description Количество новых визитов.
       * @type {number}
       */
      newCount: 0,
      /**
       * @description Количество визитов на проверку.
       * @type {number}
       */
      toVerifyCount: 0,
      /**
       * @description Количество проверенных визитов.
       * @type {number}
       */
      verifiedCount: 0,
      /**
       * @description Количество отправленных в ЕГИСЗ.
       * @type {number}
       */
      sendToEGISZCount: 0,
      /**
       * @description Количество визитов с ошибкой ЕГИСЗ.
       * @type {number}
       */
      egiszErrorCount: 0,
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isAwaitRequest: false,
      /**
       * @description Периоды.
       * @type {any[]}
       */
      periodTypes: [],
      /**
       * @description Выбранный период.
       * @type {Date[]}
       */
      selectedPeriod: [],
    };
  },
  methods: {
    /**
     * @description Получить визиты.
     * @returns {void}
     */
    fetchVisits() {
      const onFail = (error) => {
        if (!error.has('match')) {
          this.notifyFail(error.getTitle());
        }
        this.inputErrors = error.allCauses();
        this.isAwaitRequest = false;
      };
      const onSuccess = (response) => {
        this.fetchedVisits = response.items;
        this.newCount = response.new_count;
        this.toVerifyCount = response.to_verify_count;
        this.sendToEGISZCount = response.send_to_egisz;
        this.verifiedCount = response.verified_count;
        this.egiszErrorCount = response.egisz_error_count;
        this.pageCount = response.page_count;
        this.inputErrors = {};
        this.isAwaitRequest = false;
      };
      this.isAwaitRequest = true;
      const query = { ...this.viewQuery };
      if (this.selectedPeriod.length > 0) {
        query.from = getISODateStringByDate(this.selectedPeriod[0]);
        query.to = getISODateStringByDate(this.selectedPeriod[1]);
      }
      this
        .$chiefPhysicianGateway
        .viewList(query)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать выбор пресета периода.
     * @param {string} preset
     * @returns {void}
     */
    onInputPreset(preset) {
      if (preset !== 'range') {
        this.fetchVisits();
      }
    },
    /**
     * @description Обработать отмену подписи СЭМД протокола консультации.
     * @param {string} documentId Идентификатор документа.
     * @returns {void}
     */
    onCancelCdaConsultationProtocolSignature(documentId) {
      this
        .$chiefPhysicianGateway
        .cancelCdaConsultationProtocolSignature(documentId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchVisits();
          });
        });
    },
    /**
     * @description Обработать отмену выбора сертификата ЭЦП и предпросмотр
     *              СЭМД протокола консультации.
     * @returns {void}
     */
    onCancelCryptoProCertificateSelectionAndPreview() {
      this.onCancelCryptoProCertificateSelection();
      this.consultationProtocolHtml = null;
    },
    /**
     * @description Обработать подпись СЭМД протокола консультации.
     * @param {string}  visitId                  Идентификатор визита.
     * @param {boolean} needsClinicSigningNotify Необходимо предупредить о
     *                                           запрете доработок после
     *                                           подписи клиники.
     * @param {string} selectedDoctorPosition    Выбранная должность доктора.
     * @param {string} selectedDoctorSpeciality  Выбранная специальность доктора.
     * @returns {void}
     */
    onCreateCdaConsultationProtocolSignature(
      visitId,
      needsClinicSigningNotify,
      selectedDoctorPosition,
      selectedDoctorSpeciality,
    ) {
      this.needsClinicSigningNotify = needsClinicSigningNotify;
      let fetchedDocumentResult = null;
      const fetchDocument = async () => {
        if (fetchedDocumentResult !== null) {
          return fetchedDocumentResult;
        }
        fetchedDocumentResult = await this
          .$chiefPhysicianGateway
          .uploadCdaConsulatationProtocolForSigning(
            visitId,
            selectedDoctorPosition,
            selectedDoctorSpeciality,
          );
        fetchedDocumentResult.forEach(({ preview }) => {
          this.consultationProtocolHtml = preview;
        });
        return fetchedDocumentResult;
      };
      const storeSignature = (hash, signature) => fetchedDocumentResult
        .map(
          ({ document_id: documentId }) => this
            .$chiefPhysicianGateway
            .addCdaConsultationProtocolSignature(documentId, hash, signature)
            .then((result) => result.leftMap(({ title }) => title)),
        )
        .map((adding) => adding.then((result) => {
          result.forEach(() => { this.fetchVisits(); });
          return result;
        }));
      this.runCryptoProSignatureCreating(fetchDocument, storeSignature);
    },
    onInputFilter() {
      this.page = 1;
    },
    /**
     * @description Обработать отправку СЭМД протокола консультации.
     * @param {string} documentId Идентификатор документа.
     * @returns {void}
     */
    onSendCdaConsultationProtocol(documentId) {
      this
        .$chiefPhysicianGateway
        .sendCdaConsultationProtocol(documentId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchVisits();
          });
        });
    },
    /**
     * @description Обработать повтор отправки СЭМД протокола консультации.
     * @param {string} documentId Идентификатор документа.
     * @returns {void}
     */
    onSendCdaConsultationProtocolAgain(documentId) {
      this
        .$chiefPhysicianGateway
        .sendCdaConsultationProtocolAgain(documentId)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.fetchVisits();
          });
        });
    },
    /**
     * @description Показать уведомление при неактивности создания подписи.
     * @param {({title: string}[])} inactiveActions
     * @returns {void}
     */
    showInactiveCdaSignature(inactiveActions) {
      const { title } = inactiveActions[0];
      this.notifyFail(title);
    },
  },
  mixins: [
    cryptoProSignatureMixin,
    notifierMixin,
  ],
  name: 'ClinicPanelChiefPhysicianVisitList',
  watch: {
    viewQuery: {
      handler: debounce(function _() { this.fetchVisits(); }, 300),
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.chief-page {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  color: #323c47;
  &__body {
    padding: 38px 20px 48px 23px;
    width: 100%;
    overflow-y: scroll;
  }
  &__title {
    color: var(--reading-color);
  }
  &__search {
    margin-top: 20px;
    max-width: 400px;
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__filters {
    display: flex;
    flex-flow: row wrap;
    gap: 6px;
    margin: 50px 0 0 0;
    &__filter {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 17px;
      padding: 8px 15px;
      border: 1px solid #c2cfe0;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        border-color: var(--action-color);
        border-width: 2px;
        padding: 7px 14px;
      }
    }
    input:checked + &__filter {
      border-color: var(--action-color);
      border-width: 2px;
      padding: 7px 14px;
    }
  }
  &__cards {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
    margin: 37px 0;
  }
  &__card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #F2F5F8;
    font-size: 14px;
    line-height: 16px;
    &__status {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px 4px 0 0;
      padding: 8px 14px;
      font-weight: 700;
      &.verified {
        color: #1C6E0F;
        background-color: rgba(210, 237, 176, 0.7);
      }
      &.rejected {
        color: #B82428;
        background-color: #FFD1D1;
      }
      &.to-verify {
        color: #CF810D;
        background-color: #FFF2C5;
        //&:after {
        //  content: '';
        //  background-image: url("@/assets/img/status/to-verify.svg");
        //  background-size: contain;
        //  background-repeat: no-repeat;
        //  width: 19px;
        //  height: 19px;
        //}
      }
      &.new {
        color: #1F85C8;
        background-color: #D3E6FF;
      }
    }
    &__column {
      display: flex;
      flex-direction: column;
      gap: 5px;
      padding: 10px;
    }
    &__text {
      color: #90A0B7;
      a {
        color: #0489E0;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    &__input {
      ::v-deep .v-text-field {
        margin-block: 2px 6px;
        padding: 0;
        font-size: inherit;
      }
    }
    &__link {
      display: inline-flex;
      gap: 5px;
      text-align: left;
      color: #0489E0;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
      span {
        background-position: bottom;
        background-image: url("@/assets/img/pen-blue-line.svg");
        width: 16px;
        height: 16px;
      }
    }
    & &__link.warn::after {
      content: "\26A0";
      margin-left: auto;
      color: var(--warning-color);
      font-size: 1.25rem;
    }
    &__signature {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      padding: 10px;
      border-top: 1px solid #C2CFE0;
    }
    &__items {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
    &__item {
      align-items: center;
      color: var(--unfocus-color);
      display: flex;
    }
    &__item.signed {
      color: #29A34B;
    }
    &__item.signed:before {
      content: '';
      background-image: url("@/assets/img/checked/checked-green.svg");
      background-position: center;
      background-size: 80%;
      margin: 0 3px 0 0;
      width: 20px;
      height: 20px;
    }
    &__button {
      @include buttons.btn-transparent(118px, 40px, 14px);
      background-color: transparent;
      margin: 0 0 0 auto;
    }
    &__button.inactive {
      color: var(--unfocus-color);
      border-color: var(--unfocus-color);
    }
  }
  &__result {
    margin: 37px 0 0 0;
  }
  &__icon {
    display: flex;
    align-items: center;
    &.new {
      gap: 14px;
      &:before {
        width: 6px;
        height: 6px;
        background-color: #abb1a3;
        border-radius: 50%;
        content: "";
      }
    }
    &.to-verify {
      gap: 12px;
      &:before {
        width: 10px;
        height: 10px;
        border: 2px solid #faa525;
        border-radius: 50%;
        content: "";
      }
    }
    &.rejected {
      gap: 7px;
      &:before {
        background-image: url("@/assets/img/exit-red.svg");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        height: 20px;
        width: 20px;
      }
    }
    &.verified {
      gap: 7px;
      &:before {
        background-image: url("@/assets/img/status/all-checked-green.svg");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        height: 20px;
        width: 20px;
      }
    }
  }
}
@media screen and (max-width: 1560px) {
  .chief-page {
    &__cards {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
@media screen and (max-width: 1260px) {
  .chief-page {
    &__cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
@media screen and (max-width: 1024px) {
  .chief-page {
    &__cards {
      grid-template-columns: 1fr 1fr;
    }
  }
}
@media screen and (max-width: 640px) {
  .chief-page {
    &__cards {
      grid-template-columns: 1fr;
    }
  }
}
</style>
